<template>
  <div class="c-search">
    <div class="c-search-row">
      <button class="c-search-button" v-on:click="displayModelsAction()"  v-if="displayModels == false">Wybierz model</button>
    </div>
    <div class="c-search-row" v-if="displayModels == true">
      <div class="c-search-tab">
        <div class="c-search-model-list">
          <div class="c-search-model-item" v-for="(ModelItem,key) in ModelList" v-on:click="SelectModel(key)">
            <img v-bind:src="'/images/cars/'+ModelItem.url+'.png'" v-bind:alt="ModelItem.name">
            <span class="c-search-model-item-title">
              <span class="checkbox" v-bind:class="{ active: ModelItem.selected == true }">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
                  <polyline points="0 6.247 4.32 10.49 12.46 0.214" transform="translate(6 6)" fill="none" fill-rule="evenodd" stroke="currentColor" stroke-width="1"/>
                </svg>
              </span>
              <strong>{{ModelItem.name}}</strong>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  name: 'Search',
  props: [
    'ModelList'
  ],
  data: function(){
    return {
      displayModels: false
    }
  },
  methods: {
    SelectModel (key){
      if (this.ModelList[key].selected === true) {
        this.ModelList[key].selected = false
      }else {
        this.ModelList[key].selected = true
      }
      for(let i in this.ModelList){
        if (i != key) {
          this.ModelList[i].selected = false
        }
      }
      this.$emit('ModelList', this.ModelList)
    },
    displayModelsAction: function(){
      this.displayModels = true;
    }
  }
}
</script>
<style lang="scss">
  .c-search{
    margin: 0 auto;
    max-width: 1177.6px;
    width: 92%;
    padding-bottom: 3rem;
    &-row{
          display: flex;
    }
    &-model{
      &-list{
        margin: 5rem 0;
      }
      &-item{
        cursor: pointer;
        width: 25%;
        min-height: 195px;
        float: left;
        @media(max-width: 1200px){
          width: 33.333%;
        }
        @media(max-width: 1000px){
          width: 50%;
          min-height: 135px;
        }
        &-title{
          margin-top: 1rem;
          display: flex;
          justify-content: flex-start;
          align-items: center;
          strong{
            padding-left: 15px;
          }
        }
        img{
          // max-height: 125px;
          width: 88%;
        }
      }
    }
    &-by{
      display: flex;
      justify-content: center;
      vertical-align: middle;
      button{
        cursor: pointer;
        padding: 9px 20px;
        background-color: #fff;
        border: 1px solid #eceeef;
        background-color: #eceeef;
        &.active{
          background-color: #fff;
        }
        &:active{
          border: 1px solid #eceeef;
        }
      }
    }
    &-button{
      padding: 1rem 2rem;
      border: 0;
      background-color: #000;
      color: #fff;
      cursor: pointer;
    }
  }
</style>
